import { render, staticRenderFns } from "./CountrySelect.vue?vue&type=template&id=13b87524&scoped=true"
import script from "./CountrySelect.vue?vue&type=script&lang=js"
export * from "./CountrySelect.vue?vue&type=script&lang=js"
import style0 from "./CountrySelect.vue?vue&type=style&index=0&id=13b87524&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b87524",
  null
  
)

export default component.exports